module.exports = __webpack_public_path__ + "static/media/Decisions_Step1_Image24.7ce141f6.webp";